module.exports = __webpack_public_path__ + "static/img/voice-1.5962e822.png";